import * as React from "react";
import Accordion, { AccordionSlots, accordionClasses, } from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails, {accordionDetailsClasses,} from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Fade from "@mui/material/Fade";

type ReusableAccordionProps = {
  title: React.ReactNode;
  children: React.ReactNode;
  useFadeTransition?: boolean;
  defaultExpanded?: boolean;
};

const AccordionCommon: React.FC<ReusableAccordionProps> = ({title,children,useFadeTransition = false,defaultExpanded = false,}) => {
  const [expanded, setExpanded] = React.useState(defaultExpanded);

  const handleExpansion = () => {
    setExpanded((prev) => !prev);
  };

  return (
    <Accordion expanded={expanded} onChange={handleExpansion}
      slots={useFadeTransition ? { transition: Fade as AccordionSlots["transition"] } : undefined}
      slotProps={useFadeTransition ? { transition: { timeout: 400 } } : undefined}
      sx={
        useFadeTransition
          ? [
            expanded
              ? {[`& .${accordionClasses.region}`]: {height: "auto",},[`& .${accordionDetailsClasses.root}`]: {display: "block",},}
              : {[`& .${accordionClasses.region}`]: {height: 0,},[`& .${accordionDetailsClasses.root}`]: {display: "none",},},
          ]
          : undefined
      }
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography component="span">{title}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={{ direction: "rtl", textAlign: "right" }}>
        {children}
      </AccordionDetails>
    </Accordion>
  );
};

export default AccordionCommon;
